export default __webpack_public_path__ + "static/media/xmark.794a9cde.svg";